
export class SendUploadLinkModel {
    public customerId: number;
    public email: string;
    public typeId: number;
    public isInternal: boolean;
}
